module.exports = __webpack_public_path__ + "static/media/instagram-white.037627db.svg";